//Include vue.js
import { createApp, ref } from 'https://unpkg.com/vue@3/dist/vue.esm-browser.js';

const ImageBaseModal = `BCC1`; //We also have BCC2, BCC3, BCC4
const ImageBaseName = `BCC1-SNS-RD-CTW02-HCY-RCY-V1.webp`;
const ImageEndPoint = `https://content.diamonds-ring.com/assets/V1/`
const ImageBaseNameTemplate = `MODALCODE-RINGSETTING-DIAMONDSHAPE-CARATWEIGHT-RINGMETAL-VIEW.webp`;
const ImageGemBaseNameTemplate = `MODALCODE-RINGSETTING-DIAMONDSHAPE-CARATWEIGHT-GEMTYPE-VIEW.webp`;

const ApiEndPointURl = 'https://diamonds-app.evosem.com';

//Create ring builder views dictionary
const RingBuilderViews = [
	{
		name: 'Angle',
		value: 'angle',
		code: 'V1'
	},
	{
		name: 'Side',
		value: 'side',
		code: 'V2'
	},
	{
		name: 'Front',
		value: 'front',
		code: 'V3'
	},
]

//Create ring builder available modals dictionary
const RingBuilderAvailableModals = [
	{
		name: 'Solitaire Engagement Ring',
		value: 'solitaire-engagement-ring',
		code: 'BCC1'
	},
	{
		name: 'Twisted Engagement Ring',
		value: 'twisted-engagement-ring',
		code: 'BCC2'
	},
	{
		name: 'Hidden Halo Engagement Ring',
		value: 'hidden-halo-engagement-ring',
		code: 'BCC3'
	},
	{
		name: 'Six-Prong Solitaire Engagement Ring',
		value: 'six-prong-solitaire-engagement-ring',
		code: 'BCC4'
	},
]

// Center Stone Weight: for some reason there is no consistency in the code, so we need to use the following codes:
const CenterStoneWeightCodes = [
	{
		name: '0.25',
		value: '0-25-carat',
		code: 'CTW02'
	},
	{
		name: '0.50',
		value: '0-50-carat',
		code: 'CTW02'
	},
	{
		name: '1.00',
		value: '1-00-carat',
		code: 'CTW02'
	},
	{
		name: '1.50',
		value: '1-50-carat',
		code: 'CTW02'
	},
	{
		name: '2.00',
		value: '2-00-carat',
		code: 'CTW06'
	},
	{
		name: '3.00',
		value: '3-00-carat',
		code: 'CTW08'
	},
	{
		name: '4.00',
		value: '4-00-carat',
		code: 'CTW10'
	},
	{
		name: '5.00',
		value: '5-00-carat',
		code: 'CTW12'
	},
]

//Create meta types dictionary
const metalTypes = [
	{
		name: '14K White Gold',
		value: '14k-white-gold',
		code: 'HCW-RCW'
	},
	{
		name: '18K White Gold',
		value: '18k-white-gold',
		code: 'HCW-RCW' //18K White Gold code is the same as 14K White Gold
	},
	{
		name: '14K Yellow Gold',
		value: '14k-yellow-gold',
		code: 'HCY-RCY'
	},
	{
		name: '18K Yellow Gold',
		value: '18k-yellow-gold',
		code: 'HCY-RCY' //18K Yellow Gold code is the same as 14K Yellow Gold
	},
	{
		name: '14K Rose Gold',
		value: '14k-rose-gold',
		code: 'HCR-RCR'
	},
	{
		name: '18K Rose Gold',
		value: '18k-rose-gold',
		code: 'HCR-RCR' //18K Rose Gold code is the same as 14K Rose Gold
	},
	{
		name: 'Platinum',
		value: 'platinum',
		code: 'HCW-RCW' //Platinum code is the same as 14K White Gold
	},
]

//Create ring settings dictionary
const ringSettings = [
	{
		name: 'Solitaire',
		value: 'solitaire',
		code: 'SNS'
	},
	{
		name: 'UPave',
		value: 'upave',
		code: 'SUP'
	},
	{
		name: 'Bead',
		value: 'bead',
		code: 'SBV'
	},
	{
		name: 'Pave',
		value: 'pave',
		code: 'SPV'
	},
	{
		name: 'Channel',
		value: 'channel',
		code: 'SCH'
	},
]

//Create center stone shapes dictionary
const centerStoneShapes = [
	{
		name: 'Round',
		value: 'round',
		code: 'RD',
		key: 'RD'
	},
	{
		name: 'Oval',
		value: 'oval',
		code: 'OD',
		key: 'OV'
	},
	{
		name: 'Cushion',
		value: 'cushion',
		code: 'CD',
		key: 'CU'
	},
	{
		name: 'Pear',
		value: 'pear',
		code: 'PE',
		key: 'PS'
	},
	{
		name: 'Princess',
		value: 'princess',
		code: 'PD',
		key: 'PR'
	},
	{
		name: 'Emerald',
		value: 'emerald',
		code: 'ED',
		key: 'EM'
	},
	{
		name: 'Marquise',
		value: 'marquise',
		code: 'MD',
		key: 'MQ'
	},
	{
		name: 'Asscher',
		value: 'asscher',
		code: 'AD',
		key: 'AS'
	},
	{
		name: 'Radiant',
		value: 'radiant',
		code: 'RA',
		key: 'RT'
	},
	{
		name: 'Heart',
		value: 'heart',
		code: 'HD',
		key: 'HRT'
	},
]

//Create center stone types dictionary
const centerStoneTypes = [
	{
		name: 'Natural Diamond',
		value: 'natural-diamond',
		key: 'ND',
		code: 'ND'
	},
	{
		name: 'Lab-Grown Diamond',
		value: 'lab-grown-diamond',
		key: 'LG',
		code: 'LG'
	},
	{
		name: 'Emerald',
		value: 'emerald',
		key: 'EM',
		code: 'GCEM'
	},
	{
		name: 'Ruby',
		value: 'ruby',
		key: 'RB',
		code: 'GCRB'
	},
	{
		name: 'Blue Sapphire',
		value: 'blue-sapphire',
		key: 'BS',
		code: 'GCBS'
	},
]

createApp({
	//Add different delimiters for the template to avoid conflicts with shopify
	delimiters: ['[[', ']]'],
	data() {
		return {

			// Gallery
			activeGalleryIndex: 0,
			galleryObserver: null,
			gallerySlides: [],

			ready: false,

			addingToCart: false,
			optionsDropdown: null,
			selectedDialog: null,
			selectedSpecificationsTab: 'main-diamond',
			defaultSelectedRingView: 'angle', 
			centerStoneTypes: centerStoneTypes,
			RingBuilderAvailableModals: RingBuilderAvailableModals,

			selectedRingBuilderModal: RingBuilderAvailableModals.find(modal => modal.value === window.productData.productType)?.value || null,
			selectedRingMetalType: null,
			selectedRingSetting: null,
			selectedCenterStoneShape: null,
			selectedCenterStoneType: null,
			selectedCenterStoneCarat: null,
			selectedRingSize: null,
			selectedRingBuilderModalCode: RingBuilderAvailableModals.find(modal => modal.value === window.productData.productType)?.code || null,
			selectedRingMetalTypeCode: null,
			selectedRingSettingCode: null,
			selectedCenterStoneShapeCode: null,
			selectedCenterStoneTypeCode: null,
			selectedCenterStoneCaratCode: null,

			productId: window.productData.id || null,
			productData: window.productData,
			selectedRingMetalPrice: null,
			selectedCenterStonePrice: null,
			selectedSideStonePrice: null,
			selectedTotalPrice: null,
			selectedTotalPriceFormatted: null,
			selectedTotalPriceOriginal: null,
			selectedTotalPriceOriginalFormatted: null,
			selectedTotalSave: null,
			selectedTotalSaveFormatted: null,

			selectedRingViewCode: 'V1',

			selectedProductPictures: {
				angle: null,
				side: null,
				front: null,
			},

			selectedProductGemPicture: {
				angle: null,
				side: null,
				front: null,
			},

			productInquiryPanelExpanded: false,
			productInquiryPanelData: {
				name: null,
				email: null,
				phone: null,
				message: null,
				includeConfiguration: true,
			},
			productInquiryErrors: [],
			productInquiryLoading: false,
			productInquirySuccess: false,
		}
	},
	watch: {
		selectedRingBuilderModal: function(newValue) {
			this.selectedRingBuilderModalCode = RingBuilderAvailableModals.find(modal => modal.value === newValue)?.code || null;
			this.updateProductPicture()
			this.calculateTotalPrice();
		},
		selectedRingMetalType: function(newValue) {
			this.selectedRingMetalTypeCode = metalTypes.find(metaType => metaType.value === newValue)?.code || null;
			this.updateProductPicture()
			this.calculateTotalPrice();
			const metalTypeValue = metalTypes.find(metaType => metaType.value === newValue)?.value || null;
			if(metalTypeValue) {
				const price = parseFloat(window.storeMetalPrice[`price[${metalTypeValue}]`]) || null;
				//If the price is null or empty set the price to 0
				if(!price) {
					this.selectedRingMetalPrice = 0;
				} else {
					//Convert the price to cents
					const priceCents = price * 100;
					this.selectedRingMetalPrice = priceCents * window.productData.weight; //Multiply the price by the weight of the ring
				}
			}
		},
		selectedRingSetting: function(newValue) {
			this.selectedRingSettingCode = ringSettings.find(ringSetting => ringSetting.value === newValue)?.code || null;

			const selectedSideSetting = window.productData.sideSettings.filter( setting => setting.label.toLowerCase() === this.selectedRingSetting.toLowerCase())
			const selectedRingSettingPriceRules = window.storeSideStonePriceRules.filter( rule => 
				rule.color === selectedSideSetting[0]?.color && 
				rule.mmSize === selectedSideSetting[0]?.mmSize && 
				rule.quality === selectedSideSetting[0]?.quality && 
				rule.shape === selectedSideSetting[0]?.shape && 
				rule.type === selectedSideSetting[0]?.type
			)


			//Calculate the price of the side stones
			// Price per carat from the price rules * total carat of the side stones from the selectedSideSetting
			const selectedSideStonePrice = parseFloat(selectedRingSettingPriceRules[0]?.pricePerCarat || 0) * parseFloat(selectedSideSetting[0]?.totalCarat || 0) * 100; //Convert the price to cents
			this.selectedSideStonePrice = selectedSideStonePrice;
			this.selectedDialog = null;

			this.updateProductPicture();
			this.calculateTotalPrice();

		},
		selectedCenterStoneShape: function(newValue) {
			this.selectedCenterStoneShapeCode = centerStoneShapes.find(centerStoneShape => centerStoneShape.value === newValue)?.code || null;
			this.updateProductPicture()
			this.updateCenterStonePrice()
			this.calculateTotalPrice();
			this.selectedDialog = null;
		},
		selectedCenterStoneType: function(newValue) {
			this.selectedCenterStoneTypeCode = centerStoneTypes.find(centerStoneType => centerStoneType.value === newValue)?.code || null;
			this.updateProductPicture()
			this.updateCenterStonePrice()
			this.calculateTotalPrice();
		},
		selectedCenterStoneCarat: function(newValue) {
			this.selectedCenterStoneCaratCode = CenterStoneWeightCodes.find(centerStoneCarat => centerStoneCarat.value === newValue)?.code || null;
			this.updateProductPicture()
			this.updateCenterStonePrice()
			this.calculateTotalPrice();
			this.selectedDialog = null;
		},
		selectedRingMetalPrice: function() {
			this.calculateTotalPrice();
		},
		selectedCenterStonePrice: function() {
			this.calculateTotalPrice();
		},
		selectedRingSize: function() {
			this.optionsDropdown = null;
			this.selectedDialog = null;
			this.calculateTotalPrice();
		},
		selectedDialog: function() {
			console.log('selectedDialog', this.selectedDialog);
		},
	},
	created() {
		//Created
	},
	mounted() {
		//Mounted the app
		const defaultSelectedRingBuilderModal = document.querySelector('.evosem__product-info form input[name="modal-code"]:checked')?.value;
		const defaultSelectedRingMetalType = document.querySelector('.evosem__product-info form input[name="metal-type"]:checked')?.value;
		const defaultSelectedRingSetting = document.querySelector('.evosem__product-info form input[name="ring-setting"]:checked')?.value;
		const defaultSelectedCenterStoneShape = document.querySelector('.evosem__product-info form input[name="center-stone-shape"]:checked')?.value;
		const defaultSelectedCenterStoneType = document.querySelector('.evosem__product-info form input[name="center-stone-type"]:checked')?.value;
		const defaultSelectedCenterStoneCarat = document.querySelector('.evosem__product-info form input[name="center-stone-carat"]:checked')?.value;
		const defaultSelectedRingSize = document.querySelector('.evosem__product-info form input[name="ring-size"]:checked')?.value;

		this.selectedRingBuilderModal = defaultSelectedRingBuilderModal || RingBuilderAvailableModals[0].value; //Fall back to the first modal
		this.selectedRingMetalType = defaultSelectedRingMetalType || null;
		this.selectedRingSetting = defaultSelectedRingSetting || null;
		this.selectedCenterStoneShape = defaultSelectedCenterStoneShape || null;
		this.selectedCenterStoneType = defaultSelectedCenterStoneType || null;
		this.selectedCenterStoneCarat = defaultSelectedCenterStoneCarat || null;
		this.selectedRingSize = defaultSelectedRingSize || null;

		this.initialiseFromUrl();

		setTimeout(() => {
			this.updateProductPicture();
			this.ready = true;
			this.$nextTick(() => {
				this.initializeGallery();
			});
		}, 10);


	},
	methods: {
		initialiseFromUrl() {
			const params = new URLSearchParams(window.location.search);
			const urlMetalType = params.get('metal-type');
			const urlRingSetting = params.get('ring-setting');
			const urlCenterStoneShape = params.get('center-shape');
			const urlCenterStoneType = params.get('center-type');
			const urlCenterStoneCarat = params.get('center-carat');
	
	
			if(urlMetalType && window.productData.metalTypeOptions.map(metalType => metalType.toLowerCase().replaceAll(' ', '-')).some(metalType => metalType === urlMetalType)) {
				this.selectedRingMetalType = urlMetalType;
			}
	
			if(urlRingSetting && window.productData.sideSettings.map(sideSetting => sideSetting.label.toLowerCase().replaceAll(' ', '-')).some(sideSetting => sideSetting === urlRingSetting)) {
				this.selectedRingSetting = urlRingSetting;
			}
	
			if(urlCenterStoneShape && window.productData.centerStoneShape.some( centerStoneShape => centerStoneShape.toLowerCase().replaceAll(' ', '-') === urlCenterStoneShape )) {
				this.selectedCenterStoneShape = urlCenterStoneShape;
			}
	
			if(urlCenterStoneType && window.productData.centerStoneType.some( centerStoneType => centerStoneType.toLowerCase().replaceAll(' ', '-') === urlCenterStoneType )) {
				this.selectedCenterStoneType = urlCenterStoneType;
			}
	
			if(urlCenterStoneCarat && window.productData.centerCaratWeights.some(centerCaratWeight => centerCaratWeight.toLowerCase().replace(/[ .]+/g, '-') === urlCenterStoneCarat)) {
				this.selectedCenterStoneCarat = urlCenterStoneCarat;
			}
	
		},
		openSelectionDialog(dialog) {
			this.selectedDialog = dialog;
		},
		changeRingView(view) {
			this.defaultSelectedRingView = view;
		},

		toggleOptionsDropdown(dropdown) {
			this.optionsDropdown = this.optionsDropdown === dropdown ? null : dropdown; //Toggle the dropdown
		},

		initializeGallery() {
			const track = this.$refs.galleryTrack;
			if (!track) return;

			this.gallerySlides = [
				...track.querySelectorAll('.evosem__gallery__slide')
			];

			if (!this.gallerySlides.length) return;

			this.galleryObserver?.disconnect();

			this.galleryObserver = new IntersectionObserver(
				entries => {
					const visibleSlide = entries
						.filter(entry => entry.isIntersecting)
						.sort(
							(a, b) =>
								b.intersectionRatio - a.intersectionRatio
						)[0];

					if (!visibleSlide) return;

					const index = this.gallerySlides.indexOf(
						visibleSlide.target
					);

					if (index !== -1) {
						this.activeGalleryIndex = index;
					}
				},
				{
					root: track,
					threshold: [0.5, 0.75]
				}
			);

			this.gallerySlides.forEach(slide => {
				this.galleryObserver.observe(slide);
			});
		},

		goToGallerySlide(index) {
			const lastIndex = this.gallerySlides.length - 1;
			this.activeGalleryIndex = Math.max(0,Math.min(index, lastIndex));
			this.gallerySlides[
				this.activeGalleryIndex
			]?.scrollIntoView({
				behavior: 'smooth',
				block: 'nearest',
				inline: 'start'
			});
		},

		showPreviousGallerySlide() {
			this.goToGallerySlide(this.activeGalleryIndex - 1);
		},

		showNextGallerySlide() {
			this.goToGallerySlide(this.activeGalleryIndex + 1);
		},

		handleGalleryKeydown(event) {
			if (event.key === 'ArrowLeft') {
				event.preventDefault();
				this.showPreviousGallerySlide();
			}

			if (event.key === 'ArrowRight') {
				event.preventDefault();
				this.showNextGallerySlide();
			}
		},

		calculateTotalPrice() {
			this.selectedTotalPrice = (
				this.selectedRingMetalPrice + 
				this.selectedCenterStonePrice +
				this.selectedSideStonePrice +
				(window.productData.cost * 100) +
				(window.productData.prepolishCost * 100) +
				(window.productData.polishCost * 100) +
				(window.productData.rhodiumCost * 100) +
				(window.productData.solderCost * 100) +
				(window.productData.centerSetCost * 100) +
				(window.productData.settingCost * 100)
			) * (1 + window.productData.markup / 100);
			this.selectedTotalPriceFormatted = window.formatMoney(this.selectedTotalPrice);

			this.selectedTotalPriceOriginal = this.selectedTotalPrice / 0.7;
			this.selectedTotalPriceOriginalFormatted = window.formatMoney(this.selectedTotalPriceOriginal);

			this.selectedTotalSave = this.selectedTotalPriceOriginal - this.selectedTotalPrice;
			this.selectedTotalSaveFormatted = window.formatMoney(this.selectedTotalSave);
		},

		updateCenterStonePrice() {
			const centerStoneShapeKey = centerStoneShapes.find(centerStoneShape => centerStoneShape.value === this.selectedCenterStoneShape)?.key || null;
			const centerStoneTypeCode = centerStoneTypes.find(centerStoneType => centerStoneType.value === this.selectedCenterStoneType)?.key || null;
			const centerStoneCaratValue = CenterStoneWeightCodes.find(centerStoneCarat => centerStoneCarat.value === this.selectedCenterStoneCarat)?.value || null;

			try {
				const centerStonePrice = window.storeCenterStones[centerStoneTypeCode][centerStoneShapeKey][centerStoneCaratValue]
				if(centerStonePrice) {
					const centerStonePriceCents = centerStonePrice * 100;
					this.selectedCenterStonePrice = centerStonePriceCents;
				} else {
					this.selectedCenterStonePrice = 0;
				}
			} catch (error) {
				this.selectedCenterStonePrice = 0;
			}
		},

		updateProductPicture() {

			this.optionsDropdown = null; // THIS NEED TO BE SOMEWHERE ELSE


			const imageName = `${
				ImageBaseNameTemplate
				.replace('MODALCODE', this.selectedRingBuilderModalCode)
				.replace('RINGSETTING', this.selectedRingSettingCode)
				.replace('DIAMONDSHAPE', this.selectedCenterStoneShapeCode)
				.replace('CARATWEIGHT', this.selectedCenterStoneCaratCode)
				.replace('RINGMETAL', this.selectedRingMetalTypeCode)
			}`;

			const imageShadow = `${
				ImageBaseNameTemplate
				.replace('MODALCODE', this.selectedRingBuilderModalCode)
				.replace('RINGSETTING', this.selectedRingSettingCode)
				.replace('DIAMONDSHAPE', this.selectedCenterStoneShapeCode)
				.replace('CARATWEIGHT', this.selectedCenterStoneCaratCode)
				.replace('RINGMETAL-', '')
			}`;

			this.selectedProductPictures = {
				angle: `${ImageEndPoint}${imageName.replace('VIEW', RingBuilderViews[0].code)}`,
				side: `${ImageEndPoint}${imageName.replace('VIEW', RingBuilderViews[1].code)}`,
				front: `${ImageEndPoint}${imageName.replace('VIEW', RingBuilderViews[2].code)}`,
				angleShadow: `${ImageEndPoint}${imageShadow.replace('VIEW', `${RingBuilderViews[0].code}-Shadow`)}`,
				sideShadow: `${ImageEndPoint}${imageShadow.replace('VIEW', `${RingBuilderViews[1].code}-Shadow`)}`,
				frontShadow: `${ImageEndPoint}${imageShadow.replace('VIEW', `${RingBuilderViews[2].code}-Shadow`)}`,
			}

			//Only when Emerald or Ruby or Blue Sapphire is selected, we need to update the gem picture
			if (
				['emerald', 'ruby', 'blue-sapphire'].includes(this.selectedCenterStoneType)
			) {
				const gemImageName = `${
					ImageGemBaseNameTemplate
					.replace('MODALCODE', this.selectedRingBuilderModalCode)
					.replace('RINGSETTING', this.selectedRingSettingCode)
					.replace('DIAMONDSHAPE', this.selectedCenterStoneShapeCode)
					.replace('CARATWEIGHT', this.selectedCenterStoneCaratCode)
					.replace('GEMTYPE', this.selectedCenterStoneTypeCode)
				}`;

				this.selectedProductGemPicture = {
					angle: `${ImageEndPoint}${gemImageName.replace('VIEW', RingBuilderViews[0].code)}`,
					side: `${ImageEndPoint}${gemImageName.replace('VIEW', RingBuilderViews[1].code)}`,
					front: `${ImageEndPoint}${gemImageName.replace('VIEW', RingBuilderViews[2].code)}`,
				}
			} else {
				this.selectedProductGemPicture = {
					angle: null,
					side: null,
					front: null,
				}
			}

		},

		async sendProductInquiry(event) {
			event.preventDefault();
			event.stopPropagation();

			if(this.productInquiryLoading) return;

			this.productInquiryErrors = [];

			if(!this.$refs.productInquiryPanelDataName.checkValidity()) {
				this.productInquiryErrors.push('Name is required');
			}
			if(!this.$refs.productInquiryPanelDataEmail.checkValidity()) {
				this.productInquiryErrors.push('Email is required');
			}
			if(!this.$refs.productInquiryPanelDataMessage.checkValidity()) {
				this.productInquiryErrors.push('Message is required');
			}

			if(this.productInquiryErrors.length > 0) {
				return;
			}

			const data = {
				name: this.productInquiryPanelData.name,
				email: this.productInquiryPanelData.email,
				phone: this.productInquiryPanelData.phone,
				message: this.productInquiryPanelData.message,
				includeConfiguration: this.productInquiryPanelData.includeConfiguration,
			}

			if(this.productInquiryPanelData.includeConfiguration) {
				data.product_id = this.productId
				data.product_type = this.selectedRingBuilderModal
				data.product_metal_type = this.selectedRingMetalType
				data.product_ring_setting = this.selectedRingSetting
				data.product_center_stone_shape = centerStoneShapes.find(centerStoneShape => centerStoneShape.value === this.selectedCenterStoneShape)?.key || null
				data.product_center_stone_type = centerStoneTypes.find(centerStoneType => centerStoneType.value === this.selectedCenterStoneType)?.key || null
				data.product_center_stone_carat = this.selectedCenterStoneCarat
				data.product_ring_size = this.selectedRingSize
			}

			this.productInquiryLoading = true;

			setTimeout(() => {
				this.productInquiryLoading = false;
				this.productInquirySuccess = true;
				this.productInquiryErrors = [];
			}, 3000);

			try {
				const response = await fetch(`${ApiEndPointURl}/ringbuilder/api/products/inquiry`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Shopify-Shop': Shopify.shop,
					},
					body: JSON.stringify(data),
				})

				const result = await response.json();
				console.log('result', result);

			} catch (error) {
				console.error('Error sending product inquiry', error);
			}
		},

		closeProductInquiryPanel() {
			this.productInquiryPanelExpanded = false;
			this.productInquiryErrors = [];
			this.productInquirySuccess = false;
			this.productInquiryPanelData = {
				name: null,
				email: null,
				phone: null,
				message: null,
				includeConfiguration: true,
			}
		},

		async addToCart() {

			try {

				if(this.addingToCart) return;

				//Package all data into a single object
				const data = {
					product_id: this.productId,
					product_title: `${this.selectedCenterStoneCarat?.replaceAll('-', ' ').replace(' ', '.')} ${this.selectedCenterStoneShape} ${this.selectedCenterStoneType} ${this.selectedRingSetting} Engagement Ring ${this.selectedRingMetalType?.replaceAll('-', ' ')}` ,
					product_type: this.selectedRingBuilderModal,
					product_metal_type: this.selectedRingMetalType,
					product_ring_setting: this.selectedRingSetting,
					product_center_stone_shape: centerStoneShapes.find(centerStoneShape => centerStoneShape.value === this.selectedCenterStoneShape)?.key || null,
					product_center_stone_type: centerStoneTypes.find(centerStoneType => centerStoneType.value === this.selectedCenterStoneType)?.key || null,
					product_center_stone_carat: this.selectedCenterStoneCarat,
					product_ring_size: this.selectedRingSize,
				}

				this.addingToCart = true;
				
				const response = await fetch(`${ApiEndPointURl}/ringbuilder/api/products/create`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Shopify-Shop': Shopify.shop,
					},
					body: JSON.stringify(data),
				});

				const result = await response.json();

				//Add to cart with the legacy resource id and add the attributes to the cart item
				const addToCartResponse = await fetch(`/cart/add.js`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Shopify-Shop': Shopify.shop,
					},
					body: JSON.stringify({
						items: [
							{
								id: Number(result.productCreate.data.productSet.product.variants.nodes[0].legacyResourceId),
								quantity: 1,
								properties: {
									'Type': RingBuilderAvailableModals.find(modal => modal.value === this.selectedRingBuilderModal)?.name || null,
									'Metal': metalTypes.find(metalType => metalType.value === this.selectedRingMetalType)?.name || null,
									'Setting': ringSettings.find(ringSetting => ringSetting.value === this.selectedRingSetting)?.name || null,
									'Center Stone Shape': centerStoneShapes.find(centerStoneShape => centerStoneShape.value === this.selectedCenterStoneShape)?.name || null,
									'Center Stone Type': centerStoneTypes.find(centerStoneType => centerStoneType.value === this.selectedCenterStoneType)?.name || null,
									'Center Stone Carat': CenterStoneWeightCodes.find(centerStoneCarat => centerStoneCarat.value === this.selectedCenterStoneCarat)?.name || null,
									'Ring Size': this.selectedRingSize.replaceAll('-', '.'),
								},
							}
						]
					}),
				}).then( response => response.json());

				console.log('addToCartResponse', addToCartResponse);

				//Redirect to the cart page
				window.location.href = '/cart';
				this.addingToCart = false;
			} catch (error) {
				console.error('Error adding to cart', error);
				this.addingToCart = false;
			}
		},
	}
}).mount('#EvosemRingBuilder');




document.addEventListener('DOMContentLoaded', function() {
	class evosemRingBuilderCollectionItem extends HTMLElement {

		connectedCallback() {
			this.metalInputs = this.querySelectorAll('input[type="radio"][name^="metal-type"]');
			this.productPicture = this.querySelector('img[data-product-picture]');
			this.productLink = this.querySelector('a[data-product-link]');

			this.metalInputs.forEach((input) => {
				input.addEventListener('change', this.onMetalChange);
			});
		}

		onMetalChange = (event) => {

			try {

				if(
					!this.productPicture ||
					!this.productPicture?.dataset?.code ||
					!this.productPicture?.dataset?.base ||
					!this.productPicture?.dataset?.width ||
					!this.productPicture?.dataset?.height 
				) return;

				const input = event.target;
				const pictureCode = this.productPicture?.dataset?.code.replace(/HCW-RCW|HCY-RCY|HCR-RCR/g, 'METALCODE'); //Remove anything like HCW-RCW, HCY-RCY, HCR-RCR and replace it with METALCODE.
	
				let metalCode = null;
				const metalName = input.value;
	
				switch(metalName) {
					case '14k-white-gold':
						metalCode = 'HCW-RCW';
						break;
					case '14k-yellow-gold':
						metalCode = 'HCY-RCY';
						break;
					case '14k-rose-gold':
						metalCode = 'HCR-RCR';
						break;
					case '18k-white-gold':
						metalCode = 'HCW-RCW';
						break;
					case '18k-yellow-gold':
						metalCode = 'HCY-RCY';
						break;
					case '18k-rose-gold':
						metalCode = 'HCR-RCR';
						break;
					case 'platinum':
						metalCode = 'HCW-RCW';
						break;
					default:
						metalCode = 'HCW-RCW';
						break;
				}
	
				this.productPicture.src = `${this.productPicture?.dataset?.base}${pictureCode.replace('METALCODE', metalCode)}.webp?w=${this.productPicture?.dataset?.width}&h=${this.productPicture?.dataset?.height}`;

				//Replce the metal link parameter with the new metal code
				this.productLink.href = this.productLink.href.replace(`metal-type=${this.productLink?.dataset?.metalType}`, `metal-type=${metalName}`);
				this.productLink.dataset.metalType = metalName;
			} catch (error) {
				console.error('Error changing metal', error);
			}
			
		};
	}
	customElements.define('evosem-ring-builder-collection-item', evosemRingBuilderCollectionItem);
});